import { render, staticRenderFns } from "./MessageFormSettings.vue?vue&type=template&id=7812312d&"
import script from "./MessageFormSettings.vue?vue&type=script&lang=js&"
export * from "./MessageFormSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports